function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var cnb = function cnb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.length ? args.length > 1 ? args.reduce(arrayReducer, "") : arrayReducer("", args[0]) : "";
};

var arrayReducer = function arrayReducer(result, item) {
  var type = _typeof(item);

  if (type === "string") {
    return item ? result + (result && " ") + item : result;
  }

  if (Array.isArray(item)) {
    var tmp = item.length ? item.length > 1 ? item.reduce(arrayReducer, "") : arrayReducer("", item[0]) : "";
    return tmp ? result + (result && " ") + tmp : result;
  }

  if (type === "object" && item) {
    var _tmp = "";

    for (var i in item) {
      if (item[i] && item.hasOwnProperty(i)) {
        _tmp += (_tmp && " ") + i;
      }
    }

    return _tmp ? result + (result && " ") + _tmp : result;
  }

  return result;
};

export default cnb;
export { cnb };